/* Mobile Menu Toggle */
  
$('.site-nav__link--burger').click( function() {
  if ( $('#NavFade').hasClass('active') ) {
    $('#NavFade').removeClass('active');
    loeilFlipHeader();

    $('#NavFade').delay( 600 ).hide(1);
  }
  else {
    $('#NavFade').show(1);
    loeilFlipHeader();
    $('#NavFade').addClass('active');
  }
  
  $(this).toggleClass('open');
});

/* Products Page Tabs */

$('#uc-product-description-trigger').click( function(event) {
  event.preventDefault()
  
  if ( $('#uc-product-description-content-mobile').hasClass('active') ) {
     $('#uc-product-description-content-mobile').removeClass('active');
     $('#uc-product-description-content-mobile').hide();
  }
  
  else {
   $('#uc-product-description-content-mobile').show();
   $('#uc-product-description-content-mobile').addClass('active'); 
  }
});

$('#uc-product-size-trigger').click( function(event) {
  event.preventDefault()
  
  if ( $('#uc-product-size-content-mobile').hasClass('active') ) {
     $('#uc-product-size-content-mobile').removeClass('active');
     $('#uc-product-size-content-mobile').hide();
  }
  
  else {
   $('#uc-product-size-content-mobile').show();
   $('#uc-product-size-content-mobile').addClass('active'); 
  }
});

$('#uc-product-composition-trigger').click( function(event) {
  event.preventDefault()
  
  if ( $('#uc-product-composition-content-mobile').hasClass('active') ) {
     $('#uc-product-composition-content-mobile').removeClass('active');
     $('#uc-product-composition-content-mobile').hide();
  }
  
  else {
   $('#uc-product-composition-content-mobile').show();
   $('#uc-product-composition-content-mobile').addClass('active'); 
  }
});

$('#uc-product-care-trigger').click( function(event) {
  event.preventDefault()
  
  if ( $('#uc-product-care-content-mobile').hasClass('active') ) {
     $('#uc-product-care-content-mobile').removeClass('active');
     $('#uc-product-care-content-mobile').hide();
  }
  
  else {
   $('#uc-product-care-content-mobile').show();
   $('#uc-product-care-content-mobile').addClass('active'); 
  }
});

/* Reverse Header Color */

function loeilFlipHeader() {
  if ( $('.site-header').hasClass('allow-menu-flip') ) {
    if ( $('.site-header').hasClass('hero--color-0') ) {
      $('.site-header').removeClass('hero--color-0');
    }

    else {
      $('.site-header').addClass('hero--color-0');
    }   
  }
}

function loeilCheckUserScroll() {
  var $win = $(window);
  var winH = $win.height();   // Get the window height.
  var header = $('.site-header');

  $win.on("scroll", function () {
    if ($(this).scrollTop() > winH ) {
      header.removeClass('allow-menu-flip');
      header.removeClass('hero--color-0');
    } else {
      header.addClass('allow-menu-flip');
      header.addClass('hero--color-0');
    }
  }).on("resize", function(){ // If the user resizes the window
    winH = $(this).height(); // you'll need the new height value
  });
}

$( document ).ready(function() {
  if ( $('.site-header').hasClass('hero--color-0') ) {
   loeilCheckUserScroll(); 
  } 
});

/* Open Search Bar */

$('.js-toggle-search-bar').click( function(event) {
  event.preventDefault();
  
  if( $('.search-bar').hasClass('active') ) {
    $('.search-bar').removeClass('active'); 
    $('.search-bar').hide(1);
  }
  
  else {
    $('.search-bar').show(1);
    $('.search-bar').addClass('active'); 
  }
});

/* Ajax Cart Click */

$(document).ready(function() {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });
});